export default "__VITE_ASSET__D5YosoWk__"